<template>
    <div>
        <div class="left-button-one" @click="openDialog">
            免费试听
        </div>
        <div class="left-button-two" @click="addOur">
            加入我们
        </div>
        <div class="left-button-three">
            <span class="button-text">电话咨询</span>
            <span class="phone-number">400-090-1316</span>
        </div>
        <el-dialog title="" :visible.sync="localShow" :close-on-click-modal="false" :lock-scroll="false"
            :show-close="false" style="border-radius: 50px;">
            <div class="dialog-content">
                <p class="dialog-title">
                    免费领取
                </p>
                <p class="dialog-text">
                    <span style="margin-right: 10px;">圆桌星球</span>
                    <span v-if="$route.path == '/'">人文思辨体验课</span>
                    <span v-if="$route.path == '/weStory'">人文思辨体验课</span>
                    <span v-if="$route.path == '/siliconValley'">圆桌数理体验课</span>
                    <span v-if="$route.path == '/youngPerson'">少年CEO体验课</span>
                </p>
                <el-input @input="JiaoYanA" placeholder="请输入您的手机号" type="tel" v-model="input" class="dialog-input">
                    <template slot="prepend">+86</template>
                </el-input>
                <el-input @input="JiaoYanA" placeholder="请输入验证码" type="tel" v-model="inputCode"
                    class="dialog-input-code">
                    <template slot="append">
                        <div @click="getCode">{{ getCodeVisiable ? codeTime : '获取验证码' }}</div>
                    </template>
                </el-input>
                <el-button :style="{ backgroundColor: JiaoYan ? '#f6f7fa' : '#1677ff' }" :disabled="JiaoYan"
                    :loading="IsLoading" class="dialog-button" type="primary" @click="Lingqu">立即领取</el-button>
                <div class="dialog-close" @click="localShow = false">
                    <img class="closes"
                        src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E5%8F%96%E6%B6%88.png">
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import { postPhone, postTrackInfo, codePasApi, checkCodePasApi } from '@/api';

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            IsLoading: false,
            input: '',
            localShow: this.isShow,
            JiaoYan: true,
            getCodeVisiable: false,
            inputCode: '',
            codeTime: 60,
            codeInterval: null,
        };
    },
    watch: {
        isShow(newVal) {
            this.localShow = newVal;
        },
        localShow(newVal) {
            this.$emit('update:isShow', newVal);
        },

    },
    methods: {
        async getCode() {
            if (!this.input || this.getCodeVisiable) return
            const res = await codePasApi({
                phone: this.input.trim()
            })
            if (res.code == 200) {
                this.getCodeVisiable = true
            }
            this.codeInterval = setInterval(() => {
                if (this.codeTime > 1) {
                    this.codeTime--
                } else {
                    this.getCodeVisiable = false
                    this.codeTime = 60
                    clearInterval(this.codeInterval)
                }
            }, 1000)
        },
        async openDialog() {
            let type = '人文思辨课'
            switch (this.$route.path) {
                case '/':
                    type = '人文思辨课'
                    break;
                case '/siliconValley':
                    type = '圆桌数理课'
                    break;
                case '/weStory':
                    type = '我们的故事'
                    break;
                case '/youngPerson':
                    type = '少年CEO体验课'
                    break;
            }
            let data = {
                type: 20,
                content: JSON.stringify([
                    {
                        user: this.$store.state.userNumber,
                    },
                    {
                        action: '悬浮领取'
                    },
                    {
                        type: type
                    }
                ])
            }
            await postTrackInfo(data).then(() => {
                this.localShow = true;
            })

        },
        closeDialog() {
            this.localShow = false;
        },
        JiaoYanA() {
            if (this.inputCode.trim().length == 4) {
                // 校验手机号长度
                if (/^\d+$/.test(this.input) && this.input.length > 4) {
                    this.JiaoYan = false; // 输入为纯数字且长度大于4时，设置为无效
                } else {
                    this.JiaoYan = true; // 输入包含非数字或长度小于等于4时，设置为有效
                }
            } else {
                this.JiaoYan = true;
            }

        },
        addOur() {
            this.$router.push('/added')
        },
        async Lingqu() {
            window.sessionStorage.setItem('userPhone', this.input)
            const checkCodeRes = await checkCodePasApi({
                phone: this.input,
                type: 'website',
                code: this.inputCode
            })
            console.log(checkCodeRes, '=====>>>> checkCodeRes');
            if (checkCodeRes.data) {
                this.IsLoading = true;
                let leads = {
                    phone: this.input,
                    channelCategory: '自然流量',
                    // channelName: this.$route.path === '/' ? '官网-人文h51' : this.$route.path === '/siliconValley' ? '官网-硅谷h51' : '官网-少年CEOh51',
                }
                let type
                switch (this.$route.path) {
                    case '/':
                        leads.channelName = '官网-人文h51'
                        type = '人文思辨课'
                        break;
                    case '/siliconValley':
                        leads.channelName = '官网-硅谷h51'
                        type = '圆桌数理体验课'
                        break;
                    case '/weStory':
                        leads.channelName = '官网-人文h51'
                        type = '人文思辨课'
                        break;

                    default:
                        leads.channelName = '官网-人文h51'
                        type = '人文思辨课'
                        break;
                }
                let data = {
                    type: 21,
                    content: JSON.stringify([
                        {
                            user: this.$store.state.userNumber,
                        },
                        {
                            action: '领取体验课'
                        },
                        {
                           type
                        }, {
                            phone: this.input
                        }
                    ])
                }
                await postPhone(leads).then(async (res) => {
                    if (res.code == 500) {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        this.IsLoading = false;
                        return;
                    }
                    await postTrackInfo(data).then(() => {
                        this.IsLoading = false;
                        this.localShow = false;
                        this.input = null;
                        this.$message({
                            message: '领取成功',
                            type: 'success'
                        });
                    });
                });
            }

        }
    }
}
</script>

<style scoped lang="scss">
.left-button-one {
    position: fixed;
    width: 130px;
    height: 56px;
    background-color: #ed545b;
    font-family: 'JjyHeave';
    z-index: 999;
    color: #ffffff;
    font-size: 24px;
    text-align: center;
    line-height: 56px;
    text-indent: 10px;
    cursor: pointer;
    right: 0;
    bottom: 180px;
    border-radius: 36px 0 0 36px;
}

.left-button-two {
    position: fixed;
    width: 130px;
    z-index: 999;
    height: 56px;
    background-color: #1677ff;
    font-family: 'JjyHeave';
    color: #ffffff;
    font-size: 24px;
    text-align: center;
    line-height: 56px;
    text-indent: 10px;
    cursor: pointer;
    right: 0;
    bottom: 100px;
    border-radius: 36px 0 0 36px;
}

.left-button-three {
    z-index: 999;
    position: fixed;
    width: 320px;
    height: 56px;
    background-color: #ffffff;
    font-family: 'JjyHeave';
    color: #1677ff;
    font-size: 24px;
    text-align: center;
    line-height: 56px;
    right: 0;
    bottom: 20px;
    border: 0.5px solid #cfd8e5;
    transform: translateX(195px);
    border-radius: 36px 0 0 36px;
    transition: transform 0.3s ease;

}

.left-button-three:hover {
    transform: translateX(10px);
}

.phone-number {
    margin-left: 15px;
}


::v-deep .el-input-group__prepend {
    color: #000000;
    font-weight: 900;
    font-family: 'JjyHeave';
    font-size: 20px;
    border-radius: 12px 0 0 12px;
}

::v-deep .el-dialog {
    border-radius: 36px;
    width: 406px;
}

::v-deep .el-input__inner {
    height: 64px;
    font-size: 20px;
    border-radius: 0 16px 16px 0;
}

::v-deep .dialog-input-code {
    .el-input__inner {
        height: 64px;
        font-size: 20px;
        border-radius: 16px 0 0 16px;
    }

    .el-input-group__append {
        color: #000000;
        font-weight: 900;
        font-family: 'JjyHeave';
        font-size: 20px;
        border-radius: 0 12px 12px 0;
        user-select: none;
        cursor: pointer;
    }
}

.dialog-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .dialog-title {
        color: #ff4d4f;
        font-family: 'JjyHeave';
        font-size: 32px;
    }

    .dialog-text {
        color: #273143;
        font-family: 'JjyHeave';
        font-size: 24px;
        margin-top: 10px;
    }

    .dialog-input {
        width: 95%;
        margin: 40px auto 20px auto;
        height: 64px;

    }

    .dialog-input-code {
        width: 95%;
        margin: auto 20px auto;
        height: 64px;

    }

    .dialog-button {
        height: 64px;
        width: 95%;
        margin: 20px auto 20px auto;
        background-color: #1677ff;
        border: none;
        font-family: 'JjyHeave';
        font-size: 20px;
        border-radius: 12px;
    }

    .dialog-close {
        position: absolute;
        bottom: -90px;
        right: 45%;
        cursor: pointer;

        .closes {
            width: 38px;
            height: 38px;
        }

    }


}
</style>
